export const musicData = [
  {
    id: 1,
    title: "Sieh' auf die Jahre",
    subtitle: "Sag, was das Leben ist",
    poet: "Sören Padel",
    year: "2026",
    language: "Deutsch",
    tag: "Deutsch",
    image: "/images/sieh auf die Jahre WS/Daumennagel_Jahre.png",
    audio: "/images/sieh auf die Jahre WS/Sieh' auf die Jahre1.mp3",
    video: "/images/sieh auf die Jahre WS/Sieh' auf die Jahre.mp4",
    description:
      "Ein nachdenklicher Song über das Vergehen der Zeit — mal hell, mal Nebel, doch immer weit. Groß waren die Augen, die Neugier. Alles war gut oder schlecht.",
    lyrics: `Sieh' auf die Jahre
Sag, was das Leben ist
Schau durch die Zeit
Mal hell, mal Nebel, doch immer weit

Groß waren die Augen, die Neugier
Alles war gut oder schlecht
Nicht immer leicht war es im hier
Doch alles andere war weit, weit weg

Sieh' auf die Jahre
Sag, was das Leben ist
Schau durch die Zeit
Mal gnädig, mal brutal, doch immer weit

Wo sind sie, all die Versprechen
Wo hat die Ewigkeit den Pfad
Wirst Du am Leben zerbrechen
Oder ist alle Freude am Ende nur fad

Sieh' auf die Jahre
Sag, was das Leben ist
Schau durch die Zeit
Nah ist das Heute, das Morgen noch weit

Sieh' auf die Jahre
Sag, was das Leben ist
Schau durch die Zeit
Noch im Licht, doch das Ziel nicht mehr weit

(Sören Padel, 2026)`,
    status: "Demo",
  },
  {
    id: 2,
    title: "Alleine im Herbst",
    subtitle: "",
    poet: "Sören Padel",
    year: "2026",
    language: "Deutsch",
    tag: "Deutsch",
    image: "/images/Alleine im Herbst WS/Daumennagel_Liedhaus_alleine.jpg",
    audio: "/images/Alleine im Herbst WS/Alleine im Herbst (2026).mp3",
    video: "/images/Alleine im Herbst WS/Alleine im Herbst (Liedhaus).mp4",
    description:
      "Eine Herbststimmung in Klang — produziert im Liedhaus. Auch als Video verfügbar. Der Song entstand aus der Stille und Einsamkeit eines Herbsttages. Die Originalfassung von 2024 befindet sich weiter unten.",
    lyrics: null,
    status: "Demo",
  },
  {
    id: 3,
    title: "Das Morgen in unsrer Hand",
    subtitle: "",
    poet: "Sören Padel",
    year: "2026",
    language: "Deutsch",
    tag: "Deutsch",
    image: null,
    audio: "/images/In unsrer Hand WS/Das Morgen in unsrer Hand 1706_4.mp3",
    video: null,
    description:
      "Ein Song über Verantwortung und Zukunft — was wir mit dem Morgen machen, liegt in unsrer Hand. „Es gibt nichts Gutes, außer man tut es.“ Eine direkte, fast lapidare Aussage, die gleichermaßen zur Reflektion und zur Handlung auffordert.",
    lyrics: null,
    status: "Demo",
  },
  {
    id: 4,
    title: "Nézz vissza az évekre",
    subtitle: "Sieh auf die Jahre",
    poet: "Sören Padel",
    year: "2026",
    language: "Ungarisch",
    tag: "Ungarisch",
    image: null,
    audio: "/images/Nézz vissza az évekre WS/Nézz vissza az évekre.mp3",
    video: null,
    description:
      "Die ungarische Fassung von „Sieh auf die Jahre“ — dieselbe Melodie, dieselbe Sehnsucht, eine andere Sprache. „Hol fényes, hol ködös, de mindig messze.“",
    lyrics: `Nézz vissza az évekre
Mondd el, mi az élet
Nézz át az időn
Hol fényes, hol ködös, de mindig messze

Nagyok voltak a szemek, a kíváncsiság
Minden jó vagy rossz volt
Nem mindig volt könnyű itt
De minden más messze, messze volt

Nézz vissza az évekre
Mondd, mi az élet
Nézz át az időn
Néha kegyes, néha brutális, de mindig messze

Hol vannak, azok az ígéretek
Hol van az örökkévalóság ösvénye
Összetörik az élet
Vagy végül minden öröm csak unalmas

Nézz az évekre
Mondd, mi az élet
Nézz át az időn
Közel van a ma, a holnap még messze

Nézz az évekre
Mondd, mi az élet
Nézz át az időn
Még a fényben, de a cél már nem messze

(Szőren Pádel, 2026)`,
    status: "Demo",
  },
];
